<div class="page-container">
  <div class="box">
    <div fxFlex="100">
      <div fxLayout="column" fxFlexAlign="stretch">
        <div fxFlex="100">
          <mat-card appearance="outlined" style="padding: 2em">
            <mat-card-content>
              <h1>Impressum</h1>
              <div [innerHtml]="content | safeHtmlPipe"></div>

              <h5 style="padding-top: 5em">Über diese Version:</h5>
              Release: {{ buildInfo.releaseVersion }}
              <br />
              Build: {{ buildInfo.buildNumber }}
              <br />
              Source: {{ buildInfo.sourceBranch }}
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
